interface SettledPromise<T> {
  isFulfilled: boolean;
  value?: T;
  error?: any;
}

export function settle<T>(promise: Promise<T>): Promise<SettledPromise<T>> {
  return promise.then(
    (value) => ({ isFulfilled: true, value }),
    (err) => ({ isFulfilled: false, error: err }),
  );
}

export function settleAll<T>(promises: Array<Promise<T>>): Promise<Array<SettledPromise<T>>> {
  return Promise.all(promises.map((p) => settle(p)));
}
